import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleMap } from '@angular/google-maps';

import { LocationOptions, AirPollution, WeatherConditions } from '../models/user-inputs';
import { UserInputsService } from '../services/user-inputs.service';

@Component({
  selector: 'app-about-my-location',
  templateUrl: './about-my-location.component.html',
  styleUrls: ['./about-my-location.component.css']
})
export class AboutMyLocationComponent implements OnInit, AfterViewInit {

  @ViewChild(GoogleMap) map!: GoogleMap;
  
  center = {lat: 39.8097343, lng: -98.5556199};
  zoom = 4;
  options: google.maps.MapOptions = {
    disableDefaultUI: true,
    scaleControl: true,
    mapTypeControl: false,
    mapTypeId: 'roadmap',
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
      style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
    },
    zoomControl: true,
    zoomControlOptions: {position: google.maps.ControlPosition.RIGHT_BOTTOM},
  };
  drawingManager!: google.maps.drawing.DrawingManager;
  locationMarker: google.maps.Marker | null = null;
  
  loadingLocation = true;
  locationAvailable = false;
  
  latitude = 0;
  longitude = 0;
  address = '';
  
  locationOptions!: LocationOptions;
  airPollution!: AirPollution;
  weatherConditions!: WeatherConditions;

  constructor(
    private router: Router,
    private userInputsService: UserInputsService
  ) { }

  ngOnInit(): void {
    this.locationOptions = {...this.userInputsService.locationOptions};
    this.airPollution = {...this.userInputsService.airPollution};
    this.weatherConditions = {...this.userInputsService.weatherConditions};
    
    if (this.locationOptions.mode == 'address') {
      this.address = this.locationOptions.address;
    }
  }
  
  ngAfterViewInit(): void {
    if (this.locationOptions.mode == 'auto') {
      this.getLocation();
    } else if (this.locationOptions.mode == 'address' ||
               this.locationOptions.mode == 'manual') {
      this.latitude = this.locationOptions.latitude;
      this.longitude = this.locationOptions.longitude;
      this.showLocation();
    }
    
    this.drawingManager = new google.maps.drawing.DrawingManager({
      map: this.map.googleMap,
      drawingControl: true,
      // drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT,
        drawingModes: [
          google.maps.drawing.OverlayType.MARKER,
        ]
      }
    });
    
    google.maps.event.addListener(this.drawingManager, 'markercomplete',
      (marker: google.maps.Marker) => {
        if (marker.getPosition()) {
          this.latitude = marker.getPosition()!.lat();
          this.longitude = marker.getPosition()!.lng();
          this.locationOptions.mode = 'manual';
          this.showLocation();
        }
        marker.setMap(null);
        this.drawingManager.setDrawingMode(null);
      });
  }
  
  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.loadingLocation = false;
        this.locationAvailable = true;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.showLocation();
      }, (error) => {
        console.log(error);
        this.loadingLocation = false;
      });
    } else {
      console.log('Geolocation not available');
      this.loadingLocation = false;
    }
  }
  
  findAddress(): void {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': this.address}, (results, status) => {
      if (status == 'OK' && results) {
        this.latitude = results[0].geometry.location.lat();
        this.longitude = results[0].geometry.location.lng();
        this.showLocation()
      } else {
        console.log('Geocoding failed');
      }
    });
  }
  
  showLocation(): void {
    const position = new google.maps.LatLng(this.latitude, this.longitude);
    // create marker if needed
    if (!this.locationMarker) {
      this.locationMarker = new google.maps.Marker({
        position: position,
        map: this.map.googleMap
      });
    } else {
      this.locationMarker.setPosition(position);
    }
    this.map.googleMap!.setCenter(position);
    this.map.googleMap!.setZoom(8);
  }

  save(): void {
    this.locationOptions.latitude = this.latitude;
    this.locationOptions.longitude = this.longitude;
    this.locationOptions.address = this.address;
    this.userInputsService.locationOptions = {...this.locationOptions};
    this.userInputsService.airPollution = {...this.airPollution};
    this.userInputsService.weatherConditions = {...this.weatherConditions};
    this.router.navigate([''], { skipLocationChange: true });
  }
}
